import { render, staticRenderFns } from "./order.edit.vue?vue&type=template&id=36e8120e&"
import script from "./order.edit.vue?vue&type=script&lang=js&"
export * from "./order.edit.vue?vue&type=script&lang=js&"
import style0 from "./order.edit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports